/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */

/**
 * GRWM's ten beats in their order (spec G14-grwm; the playbook's Script, L9400): one line a
 * beat, the first five clip one's, the last five clip two's.
 */
export type GrwmBeat = typeof GrwmBeat[keyof typeof GrwmBeat];


export const GrwmBeat = {
  shower: 'shower',
  skin_prep: 'skin_prep',
  blush_lipstick: 'blush_lipstick',
  curls: 'curls',
  dress_reveal: 'dress_reveal',
  entryway: 'entryway',
  leaving: 'leaving',
  nerves: 'nerves',
  arrival: 'arrival',
  toast: 'toast',
} as const;
